export * from './WarningDiamondFilled';
